import { Eye, EyeOff } from "lucide-react";
import React from "react";

const LoginForm = ({
  register,
  errors,
  showPassword,
  setShowPassword,
  loading,
}) => {
  return (
    <div className="space-y-6 mt-4">
      <div>
        {/* <label
          htmlFor="email"
          className="block text-sm font-medium text-gray-700"
        >
          Email address
        </label> */}
        <div className="mt-1">
          <input
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            })}
            type="email"
            className="input bg-white"
            placeholder="Enter your email"
          />
          {errors.email && (
            <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
          )}
        </div>
      </div>

      <div>
        {/* <label
          htmlFor="password"
          className="block text-sm font-medium text-gray-700"
        >
          Password
        </label> */}
        <div className="mt-1 relative">
          <input
            {...register("password", {
              required: "Password is required",
            })}
            type={showPassword ? "text" : "password"}
            className="input pr-10 bg-white"
            placeholder="Enter your password"
          />
          <button
            type="button"
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? (
              <EyeOff className="h-5 w-5 text-gray-400" />
            ) : (
              <Eye className="h-5 w-5 text-gray-400" />
            )}
          </button>
          {errors.password && (
            <p className="mt-1 text-sm text-red-600">
              {errors.password.message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
